import { render, staticRenderFns } from "./SettingsLabelProfile.vue?vue&type=template&id=1d42bd68&scoped=true"
import script from "./SettingsLabelProfile.vue?vue&type=script&lang=js"
export * from "./SettingsLabelProfile.vue?vue&type=script&lang=js"
import style0 from "./SettingsLabelProfile.vue?vue&type=style&index=0&id=1d42bd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d42bd68",
  null
  
)

export default component.exports